import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Spinner,
  Input
} from "reactstrap";
import { consignmentService } from "../../../../../services/consignment.services";

// "Other": office adds a free text comment
const OtherModal = (props) => {
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");
  const [error, setError] = useState({});

  const modalClose = (flag) => {
    props.toggle(flag);
    setComment("");
    setError({});
  };

  const handleOther = async () => {
    setLoading(true);
    try {
      await consignmentService.otherConsignment({
        id: props.bookingId,
        comment: comment,
      });
      modalClose(true);
      props.onReload();
    } catch (errors) {
      setError(errors && typeof errors === "object" ? errors : { common: [String(errors)] });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      size="md"
      backdrop="static"
      centered
      isOpen={props.isOpen}
      toggle={() => modalClose(false)}
    >
      <ModalHeader toggle={() => modalClose(false)}>
        Other
      </ModalHeader>
      <ModalBody>
        <label>
          Comments<span className="text-danger">*</span>
        </label>
        <Input
          type="textarea"
          placeholder="Enter comments"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        {error.comment && <span className="text-danger">{error.comment}</span>}
        {error.common && <div className="text-danger">{error.common}</div>}
      </ModalBody>
      <ModalFooter>
        <div className="">
          <button
            onClick={() => modalClose(false)}
            className="btn btn-secondary mr-2"
            data-dismiss="modal"
          >
            Cancel
          </button>
          {!loading && (
            <button className="btn btn-primary" onClick={handleOther}>
              Ok
            </button>
          )}
          {loading && (
            <button className="btn btn-primary loader-icon" disabled>
              <Spinner className="img-svg"></Spinner>
            </button>
          )}
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default OtherModal;
